
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M3.29 12.29L6 15v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-4l2.71-2.71a.99.99 0 00.29-.71V8c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v3.59c0 .26.11.52.29.7zM9 0c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1s-1-.45-1-1V1c0-.55.45-1 1-1zM1.21 3.17c.39-.39 1.02-.39 1.42 0l.71.71a.996.996 0 11-1.41 1.41l-.72-.71a.996.996 0 010-1.41zm13.46.71l.71-.71a.996.996 0 111.41 1.41l-.71.71a.996.996 0 11-1.41-1.41z"}})])
          )
        }
      }
    